module.exports = __webpack_public_path__ + "media/images/emblems/Biglen-coat_of_arms-54c55a41161b48e92a45d4b2b21bf236.svg";